/* global axios */
import ApiClient from './ApiClient';

class AiAgentConfigsAPI extends ApiClient {
  constructor() {
    super('agent_bots', { accountScoped: true });
  }

  show(agentBotId) {
    return axios.get(`${this.url}/${agentBotId}/ai_agent_config`);
  }

  create(agentBotId, data) {
    return axios.post(`${this.url}/${agentBotId}/ai_agent_config`, {
      ai_agent_config: data,
    });
  }

  update(agentBotId, data) {
    return axios.patch(`${this.url}/${agentBotId}/ai_agent_config`, {
      ai_agent_config: data,
    });
  }
}

export default new AiAgentConfigsAPI();
